const tabbar = document.querySelector('.js-tabbar');
const hasSubmenu = document.querySelectorAll('.js-menu-has-sub');
const subMenuBack = document.querySelectorAll('.js-menu-back');
const trigger = document.querySelector('.js-menu-trigger');
const overlay = document.querySelector('.js-overlay');
const classNames = {
  menuSubActive: 'menu__content-wrapper--sub-active',
  menuSubVisible: 'menu__sub--visible',
};
let menuHasBeenOpen = false;

// Hide and show navigation
if (trigger) {
  trigger.addEventListener('click', function () {
    if (!menuHasBeenOpen) {
      tabbar.style.maxWidth = tabbar.offsetWidth + 'px';
      menuHasBeenOpen = true;
    }

    setTimeout(function () {
      toggleClass(trigger, 'menu__item--active');
      toggleClass(document.body, 'menu-active');

      // Be sure, no subnav is opened
      _closeSubNav();
    });
  });
}

// Close menu when clicked on the overlay
if (overlay) {
  overlay.addEventListener('click', function () {
    if (!menuHasBeenOpen) {
      return false;
    }

    toggleClass(trigger, 'menu__item--active');
    toggleClass(document.body, 'menu-active');
  });
}

// Show submenu
if (hasSubmenu) {
  [].forEach.call(hasSubmenu, (function (element) {
    element.addEventListener('click', function () {
      _openSubNav(element);
    });
  }));
}

// Hide submenu
if (subMenuBack) {
  [].forEach.call(subMenuBack, (function (element) {
    element.addEventListener('click', function () {
      _closeSubNav();
    });
  }));
}

/**
 * Open subnavigation
 * @param element
 * @private
 */
function _openSubNav(element) {
  addClass(document.querySelector('.js-menu-wrapper'), classNames.menuSubActive);
  addClass(element.nextElementSibling, classNames.menuSubVisible);

  // Scroll to top
  setTimeout(function() {
    document.querySelector('.menu__wrapper').scrollTop = 0
  }, 150);
}

/**
 * Close subnavigation
 * @private
 */
function _closeSubNav() {
  removeClass(document.querySelector('.js-menu-wrapper'), classNames.menuSubActive);

  [].forEach.call(document.querySelectorAll('.menu__sub'), (function (subnav) {
    removeClass(subnav.closest('.menu__sub'), classNames.menuSubVisible);
  }));
}
